module.exports = __webpack_public_path__ + "img/block7-img-card2.f1433845.svg";